import { createRouter, createWebHistory } from 'vue-router';

// WICHTIG: Keine statischen Imports der Komponenten hier oben!
// Das verhindert Zirkelbezüge und den "ReferenceError".

const isAuthenticated = () => {
    // Prüft, ob ein Token da ist
    return !!(localStorage.getItem('jwt_token'));
};

const routes = [
    // --- Landing Page ---
    { path: '/', redirect: '/caller-dashboard' },

    // --- Caller Auth ---
    {
        path: '/caller-login',
        name: 'CallerLogin',
        // FIX: Dynamischer Import (Lazy Loading)
        component: () => import('../components/caller/CallerLogin.vue')
    },
    {
        path: '/caller-register',
        name: 'CallerRegistration',
        component: () => import('../components/caller/CallerRegistration.vue')
    },

    // --- Operator Auth ---
    {
        path: '/operator-login',
        name: 'OperatorLogin',
        component: () => import('../components/operator/OperatorLogin.vue')
    },

    // ===================================
    // KERN-LOGIK: Call und Dashboard
    // ===================================

    // Operator (Protected)
    {
        path: '/operator-dashboard',
        name: 'OperatorDashboard',
        component: () => import('../components/operator/OperatorDashboard.vue'),
        meta: { requiresAuth: true, role: 'operator' }
    },

    // Caller Dashboard (PUBLIC LANDING PAGE)
    {
        path: '/caller-dashboard',
        name: 'CallerDashboard',
        component: () => import('../components/caller/CallerDashboard.vue')
    },
    {
        path: '/magic-login',
        name: 'MagicLogin',
        component: () => import('../components/caller/MagicLogin.vue')
    },
    {
        path: '/magic/:token',
        name: 'MagicAccess',
        component: () => import('../components/caller/MagicLogin.vue')
    },

    // --- Payment Return ---
    {
        path: '/payment/return',
        name: 'PaymentReturn',
        component: () => import('../components/caller/PaymentReturn.vue')
    },
];

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
});

// Route Guard
router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth && !isAuthenticated()) {
        if (to.meta.role === 'operator') {
            next('/operator-login');
        } else {
            next('/caller-login');
        }
    } else {
        next();
    }
});

export default router;